import { render, staticRenderFns } from "./LinkMenuItem.vue?vue&type=template&id=65e45958&scoped=true&"
import script from "./LinkMenuItem.vue?vue&type=script&lang=js&"
export * from "./LinkMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkMenuItem.vue?vue&type=style&index=0&id=65e45958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e45958",
  null
  
)

export default component.exports